var $5978f02f4e2f5026$exports = {};
$5978f02f4e2f5026$exports = {
    "collectionLabel": `Soovitused`
};


export {$5978f02f4e2f5026$exports as default};
//# sourceMappingURL=et-EE.module.js.map
